import { type CustomCellRendererProps } from 'ag-grid-react';

type BadgeVariant = 'success' | 'warning' | 'danger' | 'secondary';

type BadgeVariantResolver = BadgeVariant | ((params: CustomCellRendererProps) => BadgeVariant);

export function BadgeCell(variant: BadgeVariantResolver) {
  return function BadgeCellRenderer(params: CustomCellRendererProps) {
    if (!params.valueFormatted) {
      return '';
    }

    const resolvedVariant = typeof variant === 'function' ? variant(params) : variant;
    return (
      <div>
        <span className={`badge rounded-pill text-bg-${resolvedVariant}`}>
          {params.valueFormatted}{' '}
        </span>
      </div>
    );
  };
}
